import { render, staticRenderFns } from "./DuelsGamesElement.vue?vue&type=template&id=65e8813e&scoped=true"
import script from "./DuelsGamesElement.vue?vue&type=script&lang=js"
export * from "./DuelsGamesElement.vue?vue&type=script&lang=js"
import style0 from "./DuelsGamesElement.vue?vue&type=style&index=0&id=65e8813e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e8813e",
  null
  
)

export default component.exports